import { notificationsTypes } from './notificationsTypes'
import { v4 as uuid } from 'uuid'

export const removeNotification = (id) => (dispatch) => {

  dispatch({ type: notificationsTypes.REMOVE_NOTIFICATION, payload: id })

}

export const addNotification = (text: string, time: number, id?: string) => (dispatch, getState) => {

  const { notifications } = getState()
  if (notifications && notifications.list && notifications.list.find((notification) => notification.id === id)) return

  const notification = {
    id: id || uuid(),
    text,
    time
  }

  dispatch({ type: notificationsTypes.ADD_NOTIFICATION, payload: notification })

  setTimeout(() => {

    dispatch(removeNotification(notification.id))

  }, time)

}
